// AI assisted development

/**
 * Iframe embed chrome heights (px). SCSS that must match: `_iframe-embed-layout.scss`
 * (`$iframe-embed-toolbar-chrome-px`) and `.cc-embed-toolbar` min-height.
 */
export const IFRAME_EMBED_TOOLBAR_CHROME_PX = 55;

/** Trim a few px off measured header stack so `top` does not overshoot (see IframeEmbedService). */
export const IFRAME_EMBED_MAIN_CONTENT_TOP_PULL_UP_PX = 2;
